module.exports = __webpack_public_path__ + "static/img/1_po.9ead23d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/index/1_po.jpg
// module id = 40
// module chunks = 0